import React from "react"
import PropTypes from "prop-types"
import { Menu } from "semantic-ui-react"
import { useHistory } from "react-router"
import "./homescreen.css"

export const NavBar = ({ links, location, ...props }) => {
  const history = useHistory()
  return (
    <Menu pointing secondary>
      {links.map((el, index) => (
        <Menu.Item
          key={el.label}
          name={el.label}
          active={!!el.matches.filter(i => i.includes(location)).length}
          onClick={() => history.push(el.redirect)}
        />
      ))}
    </Menu>
  )
}

NavBar.propTypes = {
  links: PropTypes.array.isRequired,
  location: PropTypes.string
}

NavBar.defaultProps = {
  location: "organize",
  links: [
    {
      label: "Planning",
      redirect: "/organize/accounts+property",
      matches: ["organize", "understand", "plan"]
    },
    {
      label: "Learning",
      redirect: "/learning",
      matches: ["learning", "course"]
    }
    // { label: "Budgeting", redirect: "/budgeting", matches: ["budgeting"] }
  ]
}
